import { NavLink } from 'react-router-dom';
import { PlayCircle, X } from 'lucide-react';
import { useDemo } from '../../context/DemoContext';
import { NAV, STAGES } from './nav';
import { startTour } from '../Walkthrough';

export default function Sidebar({ open, onClose }) {
  const { me, setTour } = useDemo();
  const role = me?.role;
  return (
    <>
      {open && <div className="fixed inset-0 z-[1090] bg-black/60 lg:hidden" onClick={onClose} />}
      <aside data-testid="sidebar"
        className={`fixed inset-y-0 left-0 z-[1100] flex w-64 flex-col border-r border-[#1E2A45] bg-[#080C17] transition-transform duration-200 lg:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="border-b border-[#1E2A45] px-4 pb-4 pt-4">
          <div className="flex items-start justify-between">
            <img src="/assets/bwe-logo-small.png" alt="Barloworld Equipment — Caterpillar dealer logo" className="h-9 w-auto rounded-sm" data-testid="brand-logo" />
            <button className="lg:hidden text-slate-400" onClick={onClose} data-testid="sidebar-close-btn"><X className="h-5 w-5" /></button>
          </div>
          <div className="mt-1 font-mono text-[8.5px] uppercase tracking-wider text-slate-500">Logo: usage approval pending</div>
          <div className="mt-3 font-display text-[13px] font-semibold leading-tight text-white">Equipment Finance &amp; SME Performance Intelligence</div>
          <div className="mt-0.5 text-[11px] text-[#22D3EE]">Nsync Demonstration Concept</div>
        </div>
        <nav className="flex-1 overflow-y-auto px-2 py-3">
          {NAV.filter((n) => role && n.roles.includes(role)).map((n) => (
            <NavLink key={n.to} to={n.to} onClick={onClose} data-testid={`nav-${n.to.slice(1)}`}
              className={({ isActive }) => `group mb-0.5 flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${isActive ? 'bg-[#FFCD00]/10 text-[#FFCD00]' : 'text-slate-300 hover:bg-[#11192C] hover:text-white'}`}>
              <n.icon className="h-4 w-4 shrink-0" />
              <span className="flex-1 truncate">{n.label}</span>
              <span className="font-mono text-[9px] text-slate-500 group-hover:text-slate-400">{n.code}</span>
            </NavLink>
          ))}
          {role !== 'admin' && (
            <div className="mt-5 px-3">
              <div className="eyebrow mb-2">Lifecycle</div>
              <div className="space-y-1">
                {STAGES.map((s) => (
                  <NavLink key={s.key} to={s.to} onClick={onClose} data-testid={`stage-${s.key.toLowerCase()}`}
                    className="flex items-center gap-2 text-[11px] text-slate-400 hover:text-[#22D3EE]">
                    <span className="font-mono text-[#00A9CE]">{s.n}</span><span className="tracking-widest">{s.key}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          )}
        </nav>
        <div className="border-t border-[#1E2A45] p-3">
          <button className="btn-primary w-full" data-testid="start-walkthrough-btn" onClick={() => { startTour(setTour); onClose?.(); }}>
            <PlayCircle className="h-4 w-4" /> Start Executive Walkthrough
          </button>
          <div className="mt-3 text-center font-mono text-[9px] uppercase tracking-wider text-slate-500">Developed by Nsync Dimensions</div>
        </div>
      </aside>
    </>
  );
}
